<template lang="pug">
  div(v-cloak)
    v-layout(row wrap)
      v-flex(xs12 v-if="writeBackToken")
        v-alert(
          :value="true"
          type="info"
          color="accent"
          outline
        )
          span 編集中
          v-chip.my-0(small disabled outline color="accent")
            span No. {{writeBackIndex + 1}}
          v-chip.my-0(small disabled outline color="accent")
            v-avatar
              v-icon fa-cube
            span {{writeBackToken}}

      v-flex(xs12)
        v-btn(color="primary" @click="startTrial" :disabled="!progressing")
          v-icon build
          span この内容で試算する
      v-flex(xs12 sm6 md3 lg2)
        v-card
          v-card-title.primary {{$t('order.input.measurement')}}
          v-card-text
            v-select(
              :items="selection.measurement.methods"
              :label="$t('order.input.measurement_method')"
              :value="input.measurement.method"
              @input="setInput({'measurement': {'method': $event}})"
              ref="measurement_method"
              :rules="[rules.required]"
              item-text="name"
              item-value="id"
              return-object
              :no-data-text="$t('_rules.no_data_text')"
              )
            div(v-if="input.measurement.method && input.measurement.method.id === 1")
              v-text-field(
                type="number"
                :label="$t('order.input.width') + '(' + limits.outer.min + ' - ' + limits.outer.max + ')'"
                :value="input.measurement.width"
                @input="setCorrelationInput({'measurement': {'width': $event}})"
                ref="width"
                :rules="[rules.required,rules.integer,rules.positive,exrules.outer_measurement]"
                autocapitalize="off"
                suffix="mm"
                :error="!correlatedValidation.side_support || !correlatedValidation.width_gte_depth"
                :error-messages="!correlatedValidation.side_support ? [$t('order.input.correlated.side_support')] : !correlatedValidation.width_gte_depth ? [$t('order.input.correlated.width_gte_depth')] : []"
                )
              v-text-field(
                type="number"
                :label="$t('order.input.height') + '(' + limits.outer.min + ' - ' + limits.outer.max + ')'"
                :value="input.measurement.height"
                @input="setCorrelationInput({'measurement': {'height': $event}})"
                ref="height"
                :rules="[rules.required,rules.integer,rules.positive,exrules.outer_measurement]"
                autocapitalize="off"
                suffix="mm"
                :error="!correlatedValidation.side_support"
                :error-messages="!correlatedValidation.side_support ? [$t('order.input.correlated.side_support')] : []"
                )
              v-text-field(
                type="number"
                :label="$t('order.input.depth') + '(' + limits.outer.min + ' - ' + limits.outer.max + ')'"
                :value="input.measurement.depth"
                @input="setCorrelationInput({'measurement': {'depth': $event}})"
                ref="depth"
                :rules="[rules.required,rules.integer,rules.positive,exrules.outer_measurement]"
                autocapitalize="off"
                suffix="mm"
                :error="!correlatedValidation.side_support || !correlatedValidation.width_gte_depth"
                :error-messages="!correlatedValidation.side_support ? [$t('order.input.correlated.side_support')] : !correlatedValidation.width_gte_depth ? [$t('order.input.correlated.width_gte_depth')] : []"
                )
            div(v-if="input.measurement.method && input.measurement.method.id === 2")
              v-text-field(
                type="number"
                :label="$t('order.input.width') + '(' + limits.inner.min + ' - ' + limits.inner.max + ')'"
                :value="input.measurement.width"
                @input="setCorrelationInput({'measurement': {'width': $event}})"
                ref="width"
                :rules="[rules.required,rules.integer,rules.positive,exrules.inner_measurement]"
                autocapitalize="off"
                suffix="mm"
                :error="!correlatedValidation.side_support || !correlatedValidation.width_gte_depth"
                :error-messages="!correlatedValidation.side_support ? [$t('order.input.correlated.side_support')] : !correlatedValidation.width_gte_depth ? [$t('order.input.correlated.width_gte_depth')] : []"
                )
              v-text-field(
                type="number"
                :label="$t('order.input.height') + '(' + limits.inner.min + ' - ' + limits.inner.max + ')'"
                :value="input.measurement.height"
                @input="setCorrelationInput({'measurement': {'height': $event}})"
                ref="height"
                :rules="[rules.required,rules.integer,rules.positive,exrules.inner_measurement]"
                autocapitalize="off"
                suffix="mm"
                :error="!correlatedValidation.side_support"
                :error-messages="!correlatedValidation.side_support ? [$t('order.input.correlated.side_support')] : []"
                )
              v-text-field(
                type="number"
                :label="$t('order.input.depth') + '(' + limits.inner.min + ' - ' + limits.inner.max + ')'"
                :value="input.measurement.depth"
                @input="setCorrelationInput({'measurement': {'depth': $event}})"
                ref="depth"
                :rules="[rules.required,rules.integer,rules.positive,exrules.inner_measurement]"
                autocapitalize="off"
                suffix="mm"
                :error="!correlatedValidation.side_support || !correlatedValidation.width_gte_depth"
                :error-messages="!correlatedValidation.side_support ? [$t('order.input.correlated.side_support')] : !correlatedValidation.width_gte_depth ? [$t('order.input.correlated.width_gte_depth')] : []"
                )
      v-flex(xs12 sm6 md3 lg2)
        v-card
          v-card-title.primary {{$t('order.input.osb')}}
          v-card-text
            v-select(
              :items="selection.osbs"
              :label="`${$t('order.input.osb_top')}(mm)`"
              :value="input.osb.top"
              @input="setCorrelationInput({'osb': {'top': $event}})"
              ref="osb_top"
              :rules="[rules.required]"
              item-text="thick"
              item-value="id"
              :hint="input.osb.top && input.osb.top.display"
              persistent-hint
              return-object
              :error="!correlatedValidation.top_side"
              :error-messages="!correlatedValidation.top_side ? [$t('order.input.correlated.top_side')] : []"
              )
            v-select(
              :items="selection.osbs"
              :label="`${$t('order.input.osb_side')}(mm)`"
              :value="input.osb.side"
              @input="setCorrelationInput({'osb': {'side': $event}})"
              ref="osb_side"
              :rules="[rules.required]"
              item-text="thick"
              item-value="id"
              :hint="input.osb.side && input.osb.side.display"
              persistent-hint
              return-object :error="\
                !correlatedValidation.top_side ||\
                !correlatedValidation.bottom_side"
              :error-messages="\
                !correlatedValidation.top_side ? [$t('order.input.correlated.top_side')] :\
                !correlatedValidation.bottom_side ? [$t('order.input.correlated.bottom_side')] : []"
            )
            v-select(
              :items="selection.osbs"
              :label="`${$t('order.input.osb_bottom')}(mm)`"
              :value="input.osb.bottom"
              @input="setCorrelationInput({'osb': {'bottom': $event}})"
              ref="osb_bottom"
              :rules="[rules.required]"
              item-text="thick"
              item-value="id"
              :hint="input.osb.bottom && input.osb.bottom.display"
              persistent-hint
              return-object
              :error="!correlatedValidation.bottom_side"
              :error-messages="!correlatedValidation.bottom_side ? [$t('order.input.correlated.bottom_side')] : []"
              )
      v-flex(xs12 sm6 md3 lg2)
        v-card
          v-card-title.primary {{$t('order.input.edge_group')}}
          v-card-text
            v-select(
              :items="selection.edge_groups"
              :label="$t('order.input.top_side_edge_group')"
              :value="input.edge_group.top_side"
              @input="setCorrelationInput({'edge_group': {'top_side': $event}})"
              ref="top_side_edge_group"
              :rules="[rules.required]"
              item-text="name"
              item-value="id"
              return-object
              :error="!correlatedValidation.top_side"
              :error-messages="!correlatedValidation.top_side ? [$t('order.input.correlated.top_side')] : []"
              )
            v-select(
              :items="selection.edge_groups"
              :label="$t('order.input.side_side_edge_group')"
              :value="input.edge_group.side_side"
              @input="setCorrelationInput({'edge_group': {'side_side': $event}})"
              ref="side_side_edge_group"
              :rules="[rules.required]"
              item-text="name"
              item-value="id"
              return-object
              )
            v-select(
              :items="selection.edge_groups"
              :label="$t('order.input.bottom_side_edge_group')"
              :value="input.edge_group.bottom_side"
              @input="setCorrelationInput({'edge_group': {'bottom_side': $event}})"
              ref="bottom_side_edge_group"
              :rules="[rules.required]"
              item-text="name"
              item-value="id"
              return-object
              :error="!correlatedValidation.bottom_side"
              :error-messages="!correlatedValidation.bottom_side ? [$t('order.input.correlated.bottom_side')] : []"
              )
      v-flex(xs12 sm6 md3 lg2)
        v-card
          v-card-title.primary 面指定
          v-card-text
            v-checkbox(
              label="天板"
              @change="setInput({'option': {'faces': {'top': $event}}})"
              :input-value="input.option.faces.top"
              ref="faces_top"
              )
            v-checkbox(
              label="側板"
              @change="setCorrelationInput({'option': {'faces': {'side': $event}}})"
              :input-value="input.option.faces.side"
              ref="faces_side"
              :error="!correlatedValidation.no_side"
              :error-messages="!correlatedValidation.no_side ? ['側板なしの場合に側板補強を指定することはできません。'] : []"
              )
            v-checkbox(
              label="底板"
              @change="setCorrelationInput({'option': {'faces': {'bottom': $event}}})"
              :input-value="input.option.faces.bottom"
              ref="faces_bottom"
              :error="!correlatedValidation.no_clog"
              :error-messages="!correlatedValidation.no_clog ? ['底板なしの場合に桁を指定することはできません。'] : []"
              )
            span.remarks チェックをOFFにすると、その面は原価計算されません。
      v-flex(xs12 sm6 md3 lg3)
        v-card
          v-card-title.primary
            span 桁
          v-card-text
            v-select(
              :items="selection.option.clogs"
              :value="input.option.clog"
              @input="setCorrelationInput({'option': {'clog': $event}})"
              item-text="name"
              item-value="id"
              return-object
              label="桁"
              :error="!correlatedValidation.no_clog"
              :error-messages="!correlatedValidation.no_clog ? ['底板なしの場合に桁を指定することはできません。'] : []"
              )
            v-text-field(
              type="number"
              :value="input.option.clog_num"
              @input="setInput({'option': {'clog_num': $event}})"
              label="桁本数"
              ref="clog_num"
              :rules="[rules.required,rules.integer,rules.positive,rules.no_zero,exrules.deck]"
              autocapitalize="off"
              v-if="input.option.clog && input.option.clog.calculate > 0 && input.option.clog.deck === 0"
              suffix="本"
            )
            v-text-field(
              type="number"
              :value="input.option.clog_clearance"
              @input="setInput({'option': {'clog_clearance': $event}})"
              label="桁クリアランス"
              ref="clog_clearance"
              :rules="[rules.required,rules.integer,rules.positive]"
              autocapitalize="off"
              v-if="input.option.clog && input.option.clog.calculate > 0 && input.option.clog.deck === 0"
              suffix="mm"
            )
            v-text-field(
              type="number"
              :value="input.option.clog_w_blocks"
              @input="setInput({'option': {'clog_w_blocks': $event}})"
              label="W方向ブロック数"
              ref="clog_w_blocks"
              :rules="[rules.required,rules.integer,rules.positive,rules.no_zero,exrules.deck]"
              autocapitalize="off"
              v-if="input.option.clog && input.option.clog.calculate > 0 && input.option.clog.deck === 1"
              suffix="個"
            )
            v-text-field(
              type="number"
              :value="input.option.clog_d_blocks"
              @input="setInput({'option': {'clog_d_blocks': $event}})"
              label="D方向ブロック数"
              ref="clog_d_blocks"
              :rules="[rules.required,rules.integer,rules.positive,rules.no_zero,exrules.deck]"
              autocapitalize="off"
              v-if="input.option.clog && input.option.clog.calculate > 0 && input.option.clog.deck === 1"
              suffix="個"
            )
            v-select(
              :items="selection.option.clog_deck_directions"
              :label="input.option.clog.deck === 0 ? '桁渡し方向' : 'デッキ方向'"
              :value="input.option.clog_deck_direction"
              @input="setInput({'option': {'clog_deck_direction': $event}})"
              ref="clog_deck_direction"
              :rules="[rules.required]"
              :key="input.option.clog_deck_direction ? input.option.clog_deck_direction.id : 'none'"
              item-text="name"
              item-value="id"
              return-object
              v-if="input.option.clog && input.option.clog.calculate > 0"
              )
    v-layout(row wrap)
      v-flex(xs12 sm6 md3 lg2)
        v-card
          v-card-title.primary
            span 補強
          v-card-text
            v-select(
              :items="selection.option.bottom_supports"
              label="底板補強"
              :value="input.option.bottom_support"
              @input="setInput({'option': {'bottom_support': $event}})"
              ref="bottom_support"
              :rules="[rules.required]"
              item-text="name"
              item-value="id"
              return-object
              disabled
              persistent-hint
              hint="この補強オプションは廃止予定です。"
              )
            v-select(
              :items="selection.option.side_supports"
              label="側板補強"
              :value="input.option.side_support"
              @input="setCorrelationInput({'option': {'side_support': $event}})"
              ref="side_support"
              :rules="[rules.required]"
              item-text="name"
              item-value="id"
              return-object
              :error="!correlatedValidation.side_support || !correlatedValidation.no_side"
              :error-messages="!correlatedValidation.side_support ? [$t('order.input.correlated.side_support')] : !correlatedValidation.no_side ? ['側板なしの場合に側板補強を指定することはできません。'] : []"
              )
      v-flex(xs12 sm6 md3 lg2)
        v-card
          v-card-title.primary
            span オプション
          v-card-text
            v-select(
              :items="selection.option.clamps"
              label="クランプ"
              :value="input.option.clamp"
              @input="setInput({'option': {'clamp': $event}})"
              ref="clamp"
              :rules="[rules.required]"
              item-text="name"
              item-value="id"
              return-object
              )
            v-switch(
              label="ピッチ指定"
              :input-value="input.option.clamp_pitch_input"
              @change="changeClampPitchInput($event)"
              hide-details
              )
            v-text-field(
              v-if="input.option.clamp_pitch_input"
              type="number"
              label="クランプ間ピッチ(最大)"
              :value="input.option.clamp_pitch"
              @input="setInput({'option': {'clamp_pitch': $event }})"
              ref="clamp_pitch"
              :rules="[rules.required,rules.integer,rules.no_zero,rules.positive]"
              autocapitalize="off"
              suffix="mm"
              )
            v-select(
              :items="selection.option.buckles"
              label="バックル/ベルト"
              :value="input.option.buckle"
              @input="setInput({'option': {'buckle': $event}})"
              ref="buckle"
              :rules="[rules.required]"
              item-text="name"
              item-value="id"
              return-object
              )
            v-text-field(
              type="number"
              label="バックル/ベルト本数"
              :value="input.option.buckle_num"
              @input="setInput({'option': {'buckle_num': $event}})"
              ref="buckle_num"
              :rules="[rules.required,rules.integer,rules.positive,rules.no_zero,exrules.pcs]"
              autocapitalize="off"
              v-if="input.option.buckle && input.option.buckle.calculate > 0"
              suffix="本"
              )
            v-select(
              :items="selection.option.stamps"
              label="スタンプ"
              :value="input.option.stamps"
              @input="setInputStamps($event)"
              ref="stamps"
              :rules="[rules.required]"
              multiple
              item-text="name"
              item-value="id"
              chips
              return-object
              )
      v-flex(xs12 sm6 md3 lg2)
        v-card
          v-card-title.primary
            span 概要
          v-card-text
            v-text-field(
              type="number"
              label="個数"
              :value="input.overview.quantity"
              @input="setInput({'overview': {'quantity': $event}})"
              ref="quantity"
              :rules="[rules.required,rules.integer,rules.positive,rules.no_zero,exrules.box]"
              suffix="個"
              )
            v-text-field(
              type="number"
              step="0.01"
              label="原価率"
              :value="input.overview.cost_rate"
              @input="setInput({'overview': {'cost_rate': $event}})"
              ref="cost_rate"
              :rules="[rules.required,rules.positive,rules.no_zero,rules.percentage]"
              suffix="％"
              )
            v-checkbox(
              label="積み重ね"
              :value="input.overview.stack"
              @change="setInput({'overview': {'stack': $event}})"
              ref="stack"
              hide-details
            )
      v-flex(xs12 sm6 md3 lg3)
        v-card
          v-card-title.primary
            span 追加入力
            span.pl-2.rem8 ※この項目は次のページでも編集できます。
          v-card-text
            v-text-field(
              type="text"
              label="商品名"
              :value="input.overview.item_name"
              @input="setInput({'overview': {'item_name': $event}})"
              )
            v-text-field(
              type="text"
              label="備考"
              :value="input.overview.description"
              @input="setInput({'overview': {'description': $event}})"
              persistent-hint hint="備考は鑑にのみ表示されます。"
              )
            v-text-field(
              type="text"
              label="注釈"
              :value="input.overview.comment"
              @input="setInput({'overview': {'comment': $event}})"
              persistent-hint hint="注釈は箱の明細欄にのみ表示されます。"
              )
    v-layout(row wrap)
      v-flex(xs12 md5)
        v-card
          v-card-title.primary
            span 特注オプション
          v-card-text
            v-layout(
              row
              wrap
              v-for="(special, index) in input.specials"
              :key="index"
              v-if="input.specials.length > 0"
              )
              v-flex(xs7)
                v-text-field.pt-0(
                  type="text"
                  :label="'No. ' + (index + 1)"
                  :value="special.title"
                  @input="setInputSpecial({'index': index, 'special': {'title': $event }})"
                  :ref="'special_title_' + index"
                  :rules="[rules.required]"
                  autocapitalize="off"
                  )
              v-flex(xs4)
                v-text-field.pt-0(
                  type="number"
                  label="金額"
                  :value="special.amount"
                  @input="setInputSpecial({'index': index, 'special': {'amount': $event }})"
                  :ref="'special_amount_' + index"
                  :rules="[rules.required,rules.integer]"
                  autocapitalize="off"
                  suffix="円"
                  )
              v-flex(xs1)
                v-btn(flat small icon color="grey" @click="removeInputSpecial(index)")
                  v-icon close
            v-btn(color="primary" small icon @click="addInputSpecial")
              v-icon add
      v-flex(xs12 md7)
        v-card
          v-card-title.primary
            span 別枠オプション
          v-card-text
            v-layout(
              row
              wrap
              v-for="(appendix, index) in input.appendices"
              :key="index"
              v-if="input.appendices.length > 0"
              )
              v-flex(xs3)
                v-text-field.pt-0(
                  type="text"
                  :label="'No. ' + (index + 1)"
                  :value="appendix.title"
                  @input="setInputAppendix({'index': index, 'appendix': {'title': $event }})"
                  :ref="'appendix_title_' + index"
                  :rules="[rules.required]"
                  autocapitalize="off"
                  )
              v-flex(xs2)
                v-text-field.pt-0(
                  type="number"
                  label="単価"
                  :value="appendix.unit_cost"
                  @input="setInputAppendix({'index': index, 'appendix': {'unit_cost': $event }})"
                  :ref="'appendix_unit_cost_' + index"
                  :rules="[rules.required,rules.integer]"
                  autocapitalize="off"
                  suffix="円"
                  )
              v-flex(xs1)
                v-text-field.pt-0(
                  type="number"
                  label="数量"
                  :value="appendix.quantity"
                  @input="setInputAppendix({'index': index, 'appendix': {'quantity': $event }})"
                  :ref="'appendix_quantity_' + index"
                  :rules="[rules.required,rules.integer,rules.no_zero,rules.positive]"
                  autocapitalize="off"
                  )
              v-flex(xs1)
                v-select(
                  :items="selection.option.appendix_units"
                  label="単位"
                  :value="appendix.unit"
                  @input="setInputAppendix({'index': index, 'appendix': {'unit': $event }})"
                  :ref="'appendix_unit_' + index"
                  :rules="[rules.required]"
                  item-text="name"
                  item-value="id"
                  return-object
                  )
              v-flex(xs4)
                v-text-field.pt-0(
                  type="text"
                  label="備考"
                  :value="appendix.description"
                  @input="setInputAppendix({'index': index, 'appendix': {'description': $event }})"
                  autocapitalize="off"
                  )
              v-flex(xs1)
                v-btn(flat small icon color="grey" @click="removeInputAppendix(index)")
                  v-icon close
            v-btn(color="primary" small icon @click="addInputAppendix")
              v-icon add

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/common/mixins/rules'
import _ from 'underscore'
import Three, { Box, Frame, Size, Thick, Face, ClogFactory } from './Three'

export default {
  data () {
    return {
      selection: {
        measurement: {},
        option: {}
      },
      correlatedValidation: this._initializeCorrelatedValidation(),
      limits: {
        inner: {
          min: 80,
          max: 10000
        },
        outer: {
          min: 100,
          max: 10000
        }
      }
    }
  },
  mixins: [rules],
  created () {
    let self = this
    self.$ajax.get('order/input_selection').then(function (response) {
      self.selection = response.data.selection
      self.setInput(response.data.initial)
    })
  },
  computed: {
    ...mapGetters('app/order', [
      'prepare',
      'input',
      'progressing',
      'writeBackToken',
      'writeBackIndex'
    ]),
    exrules () {
      return {
        inner_measurement: value => {
          let min = this.limits.inner.min
          let max = this.limits.inner.max
          return value >= min && value <= max
            ? true
            : this.$t('_rules.between', { min: min, max: max })
        },
        outer_measurement: value => {
          let min = this.limits.outer.min
          let max = this.limits.outer.max
          return value >= min && value <= max
            ? true
            : this.$t('_rules.between', { min: min, max: max })
        },
        pcs: value => {
          return value >= 1 && value <= 10
            ? true
            : this.$t('_rules.between', { min: 1, max: 10 })
        },
        deck: value => {
          return value >= 2 && value <= 20
            ? true
            : this.$t('_rules.between', { min: 2, max: 20 })
        },
        box: value => {
          return value >= 1 && value <= 10000
            ? true
            : this.$t('_rules.between', { min: 1, max: 10000 })
        }
      }
    }
  },
  methods: {
    ...mapActions('common/loading', ['startLoading', 'endLoading']),
    ...mapActions('app/order', [
      'activateTab',
      'setInput',
      'setTrial',
      'addInputSpecial',
      'setInputSpecial',
      'removeInputSpecial',
      'addInputAppendix',
      'setInputAppendix',
      'removeInputAppendix',
      'setInputStamps'
    ]),
    _initializeCorrelatedValidation () {
      return {
        top_side: true,
        side_side: true,
        bottom_side: true,
        side_support: true,
        no_clog: true,
        width_gte_depth: true,
        no_side: true
      }
    },
    setCorrelationInput (input) {
      this.setInput(input)
      this.correlatedValidation = this._initializeCorrelatedValidation()
      let i = this.input
      let eg = i.edge_group
      let v = this.selection.edge_validations

      // 天板・側板チェック
      var ts = _.where(v, {
        edge_group: eg.top_side.id,
        thick_one: i.osb.top.id,
        thick_another: i.osb.side.id
      })
      if (ts.length === 0) {
        ts = _.where(v, {
          edge_group: eg.top_side.id,
          thick_one: i.osb.side.id,
          thick_another: i.osb.top.id
        })
      }
      if (ts.length === 0) {
        this.correlatedValidation.top_side = false
      }
      // 側板・側板チェック
      ts = _.where(v, {
        edge_group: eg.side_side.id,
        thick_one: i.osb.side.id,
        thick_another: i.osb.side.id
      })
      if (ts.length === 0) {
        this.correlatedValidation.side_side = false
      }
      // 底板・側板チェック
      ts = _.where(v, {
        edge_group: eg.bottom_side.id,
        thick_one: i.osb.bottom.id,
        thick_another: i.osb.side.id
      })
      if (ts.length === 0) {
        ts = _.where(v, {
          edge_group: eg.bottom_side.id,
          thick_one: i.osb.side.id,
          thick_another: i.osb.bottom.id
        })
      }
      if (ts.length === 0) {
        this.correlatedValidation.bottom_side = false
      }

      const width = parseInt(i.measurement.width, 10)
      const height = parseInt(i.measurement.height, 10)
      const depth = parseInt(i.measurement.depth, 10)
      // 側板補強時の箱サイズ下限チェック
      if (
        i.option.side_support.calculate &&
        (width < 300 || height < 300 || depth < 300)
      ) {
        this.correlatedValidation.side_support = false
      }
      // 面指定底板なしの場合に桁チェック
      if (!i.option.faces.bottom && i.option.clog.calculate) {
        this.correlatedValidation.no_clog = false
      }
      // 面指定側板なしの場合に側板補強チェック
      if (!i.option.faces.side && i.option.side_support.calculate === 1) {
        this.correlatedValidation.no_side = false
      }
      // 幅 >= 奥行チェック
      if (width < depth) {
        this.correlatedValidation.width_gte_depth = false
      }
      // 二方の場合初期値D
      if (this.input.option.clog.calculate === 1 && this.input.option.clog.deck === 0) {
        this.setInput({'option': {'clog_deck_direction': {...this.selection.option.clog_deck_directions[1]}}})
      } else {
        this.setInput({'option': {'clog_deck_direction': {...this.selection.option.clog_deck_directions[0]}}})
      }
    },
    async startTrial () {
      if (this.hasRuleError()) {
        this.$toastr.warning(this.$t('_rules.invalidate_message'))
        return true
      }
      const trial = (await this.$ajax.post('order/calculate', this.input)).data
        .estimation
      this.startLoading()
      const option = trial.input.option
      const image = await Three.createImage(
        new Frame(320, 320, true),
        new Box(
          new Size(trial.outer.width, trial.outer.height, trial.outer.depth),
          new Thick(
            trial.input.osb.top.thick,
            trial.input.osb.side.thick,
            trial.input.osb.bottom.thick
          ),
          new Face(option.faces.top, option.faces.side, option.faces.bottom),
          new Size(trial.clamps.width, trial.clamps.height, trial.clamps.depth),
          new Size(
            trial.order_clamp.clamp.size_x,
            trial.order_clamp.clamp.size_y,
            trial.order_clamp.clamp.size_z
          ),
          ClogFactory.create(
            option.clog.calculate === 1,
            option.clog.width,
            option.clog.height,
            option.clog.deck === 1,
            option.clog_num,
            option.clog_clearance,
            option.clog_w_blocks,
            option.clog_d_blocks,
            option.clog_deck_direction.direction
          )
        )
      )
      trial.image = image
      this.setTrial(trial)
      this.endLoading()
      this.activateTab('trial')
    },
    changeClampPitchInput (v) {
      if (!v) {
        this.setInput({ option: { clamp_pitch: 0 } })
      }
      this.setInput({ option: { clamp_pitch_input: v } })
    }
  }
}
</script>

<style scoped lang="stylus"></style>



// WEBPACK FOOTER //
// src/app/pages/Order/Components/Input.vue